const McoToken = async () => {
    // Some code that requests a token...
    return window.localStorage.getItem( "accessToken" ) || "";
}

export default McoToken;